export const muv = [
  {
    id: 1,
    name: "Toyota Innova Crysta AC",
    body: "MUV",
    seats: "6 + 1",
    doors: "5",
    engine: "2494 cc",
    transmission: "Manual / Automatic",
    fuel: "Diesel",
    ac: "AC / Non-AC",
    image: "/images/gallery/muv/crysta.png",

    gallery: [
      "/images/gallery/muv/crysta.png",
      "/images/gallery/muv/crysta-interior.jpg",
      "/images/gallery/muv/crysta-front.jpg"
    ]
  },

  {
    id: 2,
    name: "Toyota Innova Hycross AC",
    body: "MUV",
    seats: "7 + 1",
    doors: "5",
    engine: "1987 cc",
    transmission: "Automatic (Hybrid)",
    fuel: "Petrol / Hybrid",
    ac: "AC",
    image: "/images/gallery/muv/hycross.png",

    gallery: [
      "/images/gallery/muv/hycross.png",
      "/images/gallery/muv/hycross-interior.jpg",
      "/images/gallery/muv/hycross-tyre.jpg"
    ]
  }
];
